export default "__VITE_ASSET__1b6937bb__"